/*
export const TILE_LAYER_URL = 'https://korpus.cz/osmtile/mapka/{z}/{x}/{y}.png';
*/
export const TILE_LAYER_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

export const TILE_LAYER_CONFIG = {
	attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
};
export const MAP_CONFIG = {
	zoomControl: false, /* Will have custom zoomControl */
	maxZoom: 13,
	minZoom: 7, //PMa pozor zmena na desatiny moze vyrobit problem - markers sa nezobrazia
	maxBounds: L.latLngBounds(
		[46.993247, 14.259268],  /* south west */
		[51.126249, 25.354542]  /* north east */
	),
	contextmenu: true,
	zoomDelta: 0.5, /* To change zoom by 0.5 on zoom control */
	zoomSnap: 0.5, /* To change zoom by 0.5 on zoom control */
	wheelPxPerZoomLevel: 120, /* To change zoom by 0.5 on mousewheel */
};
/* export const INITIAL_VIEW = [49.982541, 15.578613];  CZ */
//export const INITIAL_VIEW = [48.73033, 19.68676]; //Pusty vrch - trochu napravo od geograf. stredu //[48.73033, 19.45692];  /* Hrb hill Lubietova - geograficky stred*/
export const INITIAL_VIEW = [48.73033, 20.60000]; //Posunute trochu dolava, aby vychod bol hned vidiet

export const INITIAL_ZOOM = 8; //PMa pozor zmena na desatiny moze vyrobit problem - markers sa nezobrazia
export const PANES = [ /* Defines visual order of overlays (z-index) */
	'cz_okresy',
	'cz_kraje',
	'cz_njo',
	'cz_hranice',
	'cz_ceska-zemska-hranice',
	'cz_moravska-zemska-hranice',
];
export const LOCATIONS_WITH_AUDIO = [ /* Currently defines which markers show speaker icon */
	'dialekt_examples',
	'ortofon_examples',
	'ucebne_pomocky_examples',
	'gemer_examples',
	'quiz_basic',
	'quiz_basic2',
	'quiz_basic3',
	'quiz_zapad',
	'quiz_stred',
	'quiz_vychod',
	'quiz_expert',
];
